(() => {
  // Newsletter signup is on hold. This asset retains legal disclosure navigation only.
  const setupLegalDisclosures = (entry) => {
    if (entry.dataset.moserLegalDisclosuresInitialized === 'true') return;
    entry.dataset.moserLegalDisclosuresInitialized = 'true';
    entry.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', () => {
        const targetId = decodeURIComponent(link.hash.slice(1));
        const details = document.getElementById(targetId);
        if (details instanceof HTMLDetailsElement) details.open = true;
      });
    });
  };
  const init = (root = document) => {
    if (root.matches?.('[data-password-newsletter-entry]')) setupLegalDisclosures(root);
    root.querySelectorAll?.('[data-password-newsletter-entry]').forEach(setupLegalDisclosures);
  };
  window.MoserNewsletterEmbed = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
